<template>
    <div class="article_modal_container">
        <div class="article_modal">
            <!-- <div class="x_btn" @click="closeModal">ⓧ</div> -->

            <div style="font-weight:700; text-align:center; margin-top:30px;">
                <div class="text_pc">잘 하셨습니다.<br>올바른 근거를 채택하였습니다.<br></div>
                <div class="text_mobile">잘 하셨습니다<br>올바른 근거를 채택<br>하였습니다.<br></div>
                <div style="font-size:22px; font-weight:400; margin:30px;">
                    300점을 획득하였습니다!
                </div>
            </div>

            <div @click="closeModal" class="select_btn">좋습니다!</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChooseClueOkModal',

    methods: {        
        closeModal: function() {
            this.$emit('close_choose_clue_ok_modal')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.article_modal_container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    /* height: 620px; */
    background-color: #000000cc;
    top: 0px;
    left: 0px;
    z-index: 2;
}


/* pc */
@media screen and (min-width: 415px) {
    .article_modal {
        position: fixed;
        width: 460px;
        height: 340px;
        background-color: white;
        left: calc((1280px / 2) - (560px / 2));
        top: calc((620px / 2) - (340px / 2) - 20px);
        padding: 10px;
        border-radius: 5px;
        overflow: hidden;
    }
    .x_btn {
        height:30px;
        font-size:26px;
        padding:0px 3px;
        font-weight:700;
        text-align: right;
        cursor:pointer;
    }
    .select_btn {
        margin-top: 10px;
        margin-bottom: 0px;
        margin-left: 20px;
        margin-right: 20px;
        font-size: 26px;
        text-align:center;
        padding: 5px;
        border:2px solid black;
        box-shadow: 2px 2px 2px gray;
        cursor:pointer;
    }
    .text_pc {
        font-size:30px;
    }
    .text_mobile {
        display: none;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .article_modal {
        position: fixed;
        width: 350px;
        height: 320px;
        background-color: white;
        left: calc(50vw - (350px / 2));
        top: calc(50vh - (320px / 2) - 30px);
        /* top: calc((620px / 2) - (340px / 2) - 20px); */
        overflow: hidden;
    }
    .select_btn {
        margin-top: 32px;
        margin-bottom: 0px;
        /* margin-left: 20px;
        margin-right: 20px; */
        font-size: 26px;
        font-weight: 700;
        text-align:center;
        padding: 10px;
        /* border:2px solid black; */
        border-top: 1px solid black;
    }
    .text_pc {
        font-size:30px;
        display: none;
    }
    .text_mobile {
        font-size:30px;
        /* display: none; */
    }
}
</style>
